// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1gMzs","filesListContainer":"PosDisputesFiles_filesListContainer__TeGX3","filesButton":"PosDisputesFiles_filesButton__35h-x"};